import _ from "lodash";

export const titleCase = value => {
  if (typeof value !== "string") {
    return;
  }

  value.replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

export const round = (number, decimalPlaces = 2) => {
  if (_.isNil(number) || typeof number !== "number") {
    return number;
  }

  return number.toFixed(decimalPlaces);
};
